/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignRunResult model module.
 * @module model/CampaignRunResult
 * @version 1.0.0
 */
export class CampaignRunResult {
  /**
   * Constructs a new <code>CampaignRunResult</code>.
   * @alias module:model/CampaignRunResult
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignRunResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignRunResult} obj Optional instance to populate.
   * @return {module:model/CampaignRunResult} The populated <code>CampaignRunResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignRunResult();
      if (data.hasOwnProperty('sent'))
        obj.sent = ApiClient.convertToType(data['sent'], 'Number');
      if (data.hasOwnProperty('progress'))
        obj.progress = ApiClient.convertToType(data['progress'], 'Number');
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('error'))
        obj.error = ApiClient.convertToType(data['error'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} sent
 */
CampaignRunResult.prototype.sent = undefined;

/**
 * @member {Number} progress
 */
CampaignRunResult.prototype.progress = undefined;

/**
 * @member {Boolean} success
 */
CampaignRunResult.prototype.success = undefined;

/**
 * @member {String} error
 */
CampaignRunResult.prototype.error = undefined;

